import { useUserStore } from '@/store/user'  // Changed from entityDataStore
import { ref, computed } from 'vue'
// import {useLogger} from "@/composables/useLogger"


/**
 * Composable for path controller functionality
 * @returns {object} - Path controller functions and computed properties
 */
export function usePermissionGuard() {
  
  const userStore = useUserStore()
  const permission = computed(() => {
    if(!userStore.userInfo) return null
    return userStore.userInfo.accessLevel
  })

  const roleHierarchy = [
    'User',
    'Supervisor',
    'CompanyAdmin',
    'OrganisationAdmin',
    'SysAdmin'
  ]

  const currentRole = computed(() => userStore.accesslevel)
  function hasRole(minRole) {
    return (
      roleHierarchy.indexOf(currentRole.value) >=
      roleHierarchy.indexOf(minRole)
    )
  }

  function canAccess(options = {}) {
    const { minRole, entityType } = options
    if( !minRole ) {
    const requiredMinRole = { 
        "users": "CompanyAdmin",
        "departments": "CompanyAdmin",
        "companies": "OrganisationAdmin",
        "organisations": "SysAdmin",
        // "entityConfigs": "SysAdmin"
      }[entityType] || "User"
    
    if( !hasRole(requiredMinRole)) return false
    // return true
    }
    else {
      if (minRole && !hasRole(minRole)) return false
    }
    return true
  }

  // function canPerform(action, context = {}) {
  //   switch (action) {
  //     case 'editUser':
  //       return hasRole('Supervisor')

  //     case 'deleteCompany':
  //       return hasRole('OrganisationAdmin')

  //     case 'viewSystemLogs':
  //       return hasRole('SysAdmin')

  //     default:
  //       return false
  //   }
  // }

  return {
    // canPerform, 
    canAccess
  }
}
